import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";

const truncate = (input, len) => input.length > len ? `${input.substring(0, len)}...` : input;

function App() {
	const dispatch = useDispatch();
	const blockchain = useSelector((state) => state.blockchain);
	const data = useSelector((state) => state.data);
	const [claimingNft, setClaimingNft] = useState(false);
	const [feedback, setFeedback] = useState(`Click 'Mint' to buy your NFT and mint it on the blockchain.`);
	const [mintAmount, setMintAmount] = useState(1);
	const [CONFIG, SET_CONFIG] = useState({
		CONTRACT_ADDRESS: "",
		SCAN_LINK: "",
		NETWORK: {
			NAME: "",
			SYMBOL: "",
			ID: 0,
		},
		SYMBOL: "",
		GAS_LIMIT: 0,
		MARKETPLACE_LINK: "",
	});

	const claimNFTs = () => {
		let costInWei = data.costInWei;
		let gasLimit = CONFIG.GAS_LIMIT;
		let totalCostWei = String(costInWei * mintAmount);
		let totalGasLimit = String(gasLimit * mintAmount);
		console.log(totalCostWei, totalGasLimit);
		setFeedback(`Minting your Paper Bag Head(s)...`);

		setClaimingNft(true);

		blockchain.smartContract.methods
			.mint(mintAmount)
			.send({
				gasLimit: String(totalGasLimit),
				to: CONFIG.CONTRACT_ADDRESS,
				from: blockchain.account,
				value: totalCostWei,
			})
			.once("error", (err) => {
				console.log(err);
				setFeedback("Something went wrong. Please try again later.");
				setClaimingNft(false);
			})
			.then((receipt) => {
				console.log(receipt);
				setFeedback(`🎉 Congrats! You just minted your very own Paper Bag Head(s)! View it on Opensea.io! 🥳`);
				setClaimingNft(false);
				dispatch(fetchData(blockchain.account));
				party();
			});
	};

	const changeMintAmount = (editAmountBy) => {
		let newMintAmount = mintAmount + editAmountBy;
		if (newMintAmount < 1) newMintAmount = 1;
		else if (newMintAmount > 10) newMintAmount = 10;
		setMintAmount(newMintAmount);
	};

	const getData = () => {
		if (blockchain.account !== "" && blockchain.smartContract !== null) {
			dispatch(fetchData(blockchain.account));
		}
	};

	const getConfig = async () => {
		const configResponse = await fetch("/config/config.json", {
			headers: { "Content-Type": "application/json", Accept: "application/json" },
		});
		const config = await configResponse.json();
		SET_CONFIG(config);
	};

	useEffect(() => { getConfig(); }, []);
	useEffect(() => { getData(); }, [blockchain.account]);

	return (
		<div className="main">
			<div className="mainBack">
				<div className="mainTop"></div>
				<div className="mainBottom">
					<div className="mainShadow"></div>
				</div>
			</div>
			<div style={{position: "relative"}}>
				<div style={{width: "100%", padding: 20}}>
					<div style={{display: "inline-block"}}>
						<span className="sh1">PAPER BAG HEADS <span className="greenBox d-md-none">MINT</span></span>
						<p className="sP paperFont">PAPER PROJECTS</p>
					</div>
					<div className="" style={{display: "inline-block", float: "right"}}>
						<span className="d-none d-md-block sh1 greenBox rightAlign">MINT SHOPPING BAG</span>
						<p className="sP rightAlign"><a className="a" target={"_blank"} href={CONFIG.SCAN_LINK}>{truncate(CONFIG.CONTRACT_ADDRESS, 20)}</a></p>
						{data.mintActive ? (
							<>
							<p className="d-sm-block d-md-none rightAlign sP">{data.totalSupply} / {data.maxTokens} MINTED</p>
							<p className="d-sm-block d-md-none rightAlign sP">1 {CONFIG.SYMBOL} = {data.cost} {CONFIG.NETWORK.SYMBOL}</p>
							</>
						): (<></>)}
					</div>
				</div>
				<div className="spacerTop"></div>

				<div className="inlinewrapper">

					<div className="block d-none d-md-inline-block">
						<div className="bag" style={{backgroundImage: "url('images/bag1.png')", paddingTop: 180}}>
							<div style={{textAlign: "right", marginRight: 70}}>
								{data.mintActive ? (
								<>
									<h2 className="weightHeavy colorLight">{data.totalSupply} /<br />{data.maxTokens}</h2>
									<h6 className="colorLight">MINTED</h6>
								</>
								): (<></>)}
							</div>
						</div>
					</div>

					<div className="block">
						<div className="bag" style={{backgroundImage: "url('images/bag2.png')"}}>
								{(Number(data.totalSupply) >= data.maxTokens) ? (
										<div className="btn custombtn disabled" style={{backgroundColor: '#EC4A4A', opacity: 100, marginTop: 130}}></div>
								) : (
									<>
										{(blockchain.account === "" || blockchain.smartContract === null) ? (
												<div className="custombtn blink" style={{backgroundColor: '#ADFF92', border: '2px solid white', marginTop: 130}}
													onClick={(e) => { e.preventDefault(); dispatch(connect()); getData(); }}
												><span style={{opacity: 100}}>CONNECT</span></div>
										) : (
											<>
											{data.mintActive ? (
												<div style={{display: "inline-block", marginTop: 100}} >
													<p style={{width: 150}}>Click "+" to mint more than 1 NFT.</p>

													<div>
														<button className="btn btn-dark d-inline-block" disabled={claimingNft ? 1 : 0} onClick={(e) => { e.preventDefault(); changeMintAmount(-1); }}>-</button>
														<div className="spacerSmall d-inline-block"></div>
														<button className="btn btn-lg btn-light d-inline-block disabled" style={{opacity: 100}}>{mintAmount}</button>
														<div className="spacerSmall d-inline-block"></div>
														<button className="btn btn-dark d-inline-block" disabled={claimingNft ? 1 : 0} onClick={(e) => { e.preventDefault(); changeMintAmount(1); }}>+</button>
													</div>
													<div className="spacerLarge"></div>
													<div className="custombtn" style={{backgroundColor: "#ADFF92"}} disabled={claimingNft ? 1 : 0}
														onClick={(e) => { e.preventDefault(); claimNFTs(); getData(); }}
													>{claimingNft ? "BUSY" : "MINT"}</div>
												</div>
											) : (
												<div className="custombtn" style={{backgroundColor: '#DB5651', color: "white", marginTop: 130}}>
													INACTIVE
												</div>
											)}
											</>
										)}
									</>
								)}
						</div>
					</div>

					<div className="block d-none d-md-inline-block">
						<div className="bag" style={{backgroundImage: "url('images/bag3.png')", paddingTop: 180}}>
							<div style={{textAlign: "left", marginLeft: 70}}>
							{data.mintActive ? (
								<>
								<h2 className="weightHeavy colorLight">1 {CONFIG.SYMBOL} = <br />{data.cost}<small> {CONFIG.NETWORK.SYMBOL}</small></h2>
								<h6 className="colorLight">Excluding gas fee</h6>
								</>
								): (<></>)}
							</div>
						</div>
					</div>

				</div>
				<div className="spacerTop"></div>

				<div className="container text-center" style={{width: '100%'}}>
					{(Number(data.totalSupply) >= data.maxTokens) ? (
						<h5>Mint has ended. View {CONFIG.SYMBOL} NFTs on <a className="a" target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>Opensea.</a></h5>
					) : (
						<>
							{(blockchain.account === "" || blockchain.smartContract === null) ? (
									<>
										<h5>Connect to the {CONFIG.NETWORK.NAME} network.</h5>
										{ blockchain.errorMsg !== "" ? (<p style={{color: "red"}}>{blockchain.errorMsg}</p>) : null }
									</>
							) : (
								<>
								{data.mintActive ? (
									<h5>{feedback}</h5>
								) : (
									<h5>You can't buy a PBH just yet. We will activate the mint shortly. Watch out for an annoucement on Twitter!</h5>
								)}
								</>)
							}
						</>
					)}
				</div>
			</div>
	</div>
	);
}

export default App;
